export default __webpack_public_path__ + "static/media/gold 4F.8104e8d1.png";